module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAWCAYAAADXYyzPAAAABmJLR0QAAAAAAAD5Q7t/AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH4gUDDzoYcJQxpQAAAHVJREFUSMfNlTkOwCAMBPH+/8EUIFOlIVGEb1xR2HtMAzEzt4JBKxrM0SnbdI5OeB6ZprWo9yQZbV+NI8137XrUka2/NHG66Gl6F2rP1n8a0B5aTO9EbWl9cgMvIekuvAVL/mNJOHgJS4kgslU4ak0YWI20BBYqnVagm4CzNQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/baise_jiantou_geren_icon.png
// module id = 387
// module chunks = 0